// framework
import React, { useCallback } from "react";
// constants
import { MESSAGES } from "constants/constants";
// styles
import styles from "./CategorySelectView.module.scss";
// components
import Button from "components/Shared/Button/Button";
import Player from "components/Shared/Player/Player";

export default function CategorySelectView({ categories = [], player, room }) {
    const onSelect = useCallback((categoryIndex) => {
        room?.send(MESSAGES.TO_SERVER.SELECT_CATEGORY, { index: categoryIndex });
    }, [room]);

    return (
        <div className={styles.categoryView}>
            <Player className={styles.player} player={player} room={room} />
            <div className={styles.categories}>
                {categories
                    .filter(Boolean)
                    .map((label, idx) => (
                        <Button key={idx} className={styles.button} onClick={() => onSelect(idx)} >
                            {label}
                        </Button>
                    ))}
            </div>
        </div>
    );
}